import { render, staticRenderFns } from "./r-tile.vue?vue&type=template&id=4b7d63e2"
import script from "./r-tile.vue?vue&type=script&lang=js"
export * from "./r-tile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b7d63e2')) {
      api.createRecord('4b7d63e2', component.options)
    } else {
      api.reload('4b7d63e2', component.options)
    }
    module.hot.accept("./r-tile.vue?vue&type=template&id=4b7d63e2", function () {
      api.rerender('4b7d63e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/utils/r-tile.vue"
export default component.exports